import { button } from '../../../../../component/component'

export default function(o,c){

  var play =
    button(null,'fi-play')
    .click(function(){
      o.video.play()
      o.playing = true
      o.loopStart = o.video.currentTime
      o.player.setFilter()
      c.stop.show()
      c.play.hide()
    })

  return play

}



// WEBPACK FOOTER //
// ./src/client/view/admin/controls/buttons/play/play.js